import { render, staticRenderFns } from "./EditComm.vue?vue&type=template&id=32681b85&"
import script from "./EditComm.vue?vue&type=script&lang=js&"
export * from "./EditComm.vue?vue&type=script&lang=js&"
import style0 from "./EditComm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports